<template>
  <b-modal
    id="submitFile"
    :centered="true"
    title="Do you want to submit the claim file(s)?"
    :hide-footer="true"
    @hidden="hideModal()"
    @shown="handleModalShown"
    size="lg"
    close-on-backdrop
  >
    <div class="file-content-wrap">
      <div>
        <label>Plan Name: </label>
        <p>{{ claimData.plan_overview.plan_name }}</p>
      </div>
      <div
        v-if="claimData.is_LifeOr7kEnabled"
        class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
      >
        <label>Death Date <span style="color: red;">*</span></label>
        <div class="date-picker-wrap">
        <input 
        id="claim-date"
        type="date"
        v-model="death_date"
        :max="maxDate"
        class="form-control"
        @input="onInput"
      />
      </div>
        <div
          class="text-danger"
          v-if="
            touched &&
              !$v.death_date.$pending &&
              (!$v.death_date.$model || !$v.death_date.$dirty)
          "
        >
          Death Date is required
        </div>
      </div>
      <p class="mb-3">
        The file(s) you want to upload:
      </p>
      <div class="d-flex flex-wrap mb-2">
        <div v-for="file in files" :key="file.id" class="mb-2 pr-0 mr-2">
          <div class="mb-2 pl-2 file-name-wrap pb-1">
            <a :href="file.filepath" target="_blank" class="clr-active"
              ><span class="pr-3 pb-4">{{ file.filename }}</span>
              <div class="download-icon">
                <i
                  class="fas fa-download ml-2"
                  style="font-size: 10px; position: absolute; top: 5px; left: 5px;"
                ></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div style="margin-right: 10px;" class="cancel-btn mr-3">
        <button @click="hideModal">Cancel</button>
      </div>
      <div class="submit-btn upload-submit">
        <button @click="submitHandler">Submit</button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import axios from "axios";
import helper from "@/resource/Helper";
import { action_origin } from "@/utils/constant";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FileSubmitModal",
  data() {
    return {
      death_date: "",
      isClaim: true,
      touched: false,
      maxDate: new Date().toISOString().split("T")[0],
    };
  },

  props: {
    files: {
      type: Array,
      default: () => [],
    },
    claimData: {
      type: Object,
    },
  },
  validations: {
    death_date: {
      required,
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("submitFile");
      document.body.style.overflow = "";
      this.touched = false;
      this.death_date=''
    },
    disableDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
    onInput() {
      this.formTouched = true; 
    },
    handleModalShown() {
      document.body.style.overflow = "hidden";
    },
    submitHandler() {     
      if (this.claimData.is_LifeOr7kEnabled) {
        this.submitClaimData();
      } else {
        this.submitData();
      }
    },
    submitClaimData() {
      this.touched = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      let loader = this.$loading.show();
      const url = "v2/prudential-claim/store-death-date";
      const formattedDate = new Date(this.death_date).toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }
      );
      const payload = {
        user_id: this.claimData?.claim_for || "",
        death_date: formattedDate,
      };

      axios
        .post(url, payload)
        .then((response) => {
          if (response.data?.status === "success") {
            this.submitData();
          } else {
            helper.infoMessage(
              this,
              "error",
              response.data?.message || "Unknown error"
            );
          }
        })
        .catch((error) => {
          const errorMessage =
            error.response.data.errors.death_date[0] || "Submission failed.";
          helper.infoMessage(this, "error", errorMessage);
        })
        .finally(() => {
          loader.hide();
        });
    },
    submitData() {
      let loader = this.$loading.show();
      let url = "v2/prudential-claim/submit-claim";

      let payload = {
        user_id: this.claimData.claim_for,
        claim_id: this.files[0].claim_id,
        policy_id: this.claimData.policy_id,
        plan_id: this.claimData.pid,
        submitted_id: this.$store.getters.repId,
        submitted_by: action_origin,
      };
      axios
        .post(url, payload)
        .then((response) => {
          if (response.data.status == "success") {
            helper.infoMessage(
              this,
              response.data.status,
              response.data.message
            );
          }
          this.$parent.getData();
          this.hideModal();
        })
        .catch((error) => {
          if (error.response.data.status == "error") {
            helper.infoMessage(this, "error", error.response.data.message);
          }
          this.$parent.getData();
          this.hideModal();
        })
        .finally(() => {
          loader.hide();
          this.death_date = "";
        });
    },
  },
};
</script>
<style>
.date-picker-wrap input[type="date"] {
  width: 100%; 
  padding: 10px; 
  border: 1px solid #ced4da; 
  border-radius: 4px; 
  background-color: #fff; 
  font-size: 16px; 
  color: #495057; 
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1); 
  transition: border-color 0.2s ease, box-shadow 0.2s ease; 
}

.date-picker-wrap input[type="date"]:focus {
  outline: none; 
  border-color: #80bdff; 
  box-shadow: 0 0 5px rgba(128, 189, 255, 0.5); 
}

.date-picker-wrap input[type="date"]::placeholder {
  color: #6c757d; 
  font-style: italic; 
}

.error_message {
  font-size: 14px; 
  color: #dc3545; 
 
}

</style>